import EditCustomDomainListDashboard from "./EditCustomDomainListDashboard";

export default EditCustomDomainListDashboard;
